export default "__VITE_ASSET__B0QqFC2c__"